import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HotelDetailComponent } from "./hotel-detail.component";
import { HotelDetailRoutingModule } from "./hotel-detail-routing.module";
import { StarsRatingModule } from "src/app/libs/ui/components/stars-rating/stars-rating.module";
import { RoomDetailedCardModule } from "src/app/pages/hotels/hotels-pages/room-detail/ui/components/room-detailed-card/room-detailed-card.module";
import { HotelStarsModule } from "src/app/libs/ui/components/hotel-stars/hotel-stars.module";
import { SearchFormModule } from "src/app/libs/ui/components/search-form/search-form.module";
import { TicketHeroModule } from "src/app/libs/ui/components/ticket-hero/ticket-hero.module";
import { MatTooltipModule } from "@angular/material/tooltip";
import { ImageDialogComponent } from "../image-dialog/image-dialog.component";
import { ImageGalleryComponent } from "../image-gallery/image-gallery.component";
import { RoomDetailModule } from "../room-detail/room-detail.module";
import { I18nModule } from "src/app/core/languages-support/i18n.module";
import { AppSupportedLanguages } from "src/app/core/languages-support/i18n-config.service";
import { ViewGoogleMapComponent } from "../../ui/components/view-google-map/view-google-map.component";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";

@NgModule({
  declarations: [HotelDetailComponent,
    ImageGalleryComponent,
    ImageDialogComponent,
    ViewGoogleMapComponent
  ],
  imports: [
    CommonModule,
    HotelDetailRoutingModule,
    StarsRatingModule,
    RoomDetailedCardModule,
    I18nModule.forRoot(AppSupportedLanguages),
    HotelStarsModule,

    SearchFormModule,
    TicketHeroModule,
    MatTooltipModule,
    RoomDetailModule,
    MatIconModule,
    MatDialogModule,
  ],
  exports: [HotelDetailComponent],
})
export class HotelDetailModule {}
